function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { createBreakpointMap } from '../helpers/styled-helpers';
import { buttonSizeToTypographyStyleMap, StyledButton, StyledButtonInnerArea, StyledTypography } from './style';
export default class Button extends React.Component {
  render() {
    var styleTypeMap = createBreakpointMap(this.props.styleType);
    var sizeMap = createBreakpointMap(this.props.size);
    var typographyType = [];
    Object.keys(sizeMap).forEach(breakpoint => {
      var size = sizeMap[breakpoint];
      typographyType.push(buttonSizeToTypographyStyleMap[size]);
    });
    return /*#__PURE__*/React.createElement(StyledButton, _extends({}, this.props, {
      styleTypeMap: styleTypeMap,
      sizeMap: sizeMap
    }), /*#__PURE__*/React.createElement(StyledButtonInnerArea, {
      disabled: this.props.disabled,
      styleTypeMap: styleTypeMap,
      sizeMap: sizeMap
    }, /*#__PURE__*/React.createElement(StyledTypography, {
      type: typographyType
    }, this.props.children)));
  }

}